
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kiosks/[cName]/products",
      function () {
        return require("private-next-pages/kiosks/[cName]/products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kiosks/[cName]/products"])
      });
    }
  